// store/balance/createBalanceSlice.ts

import { StateCreator } from 'zustand';
import { BalanceState, balanceInitialState } from './balanceInitialState';
import { BalanceDto, Compte } from '../../types';
import { BalanceRow } from '../../components/Balance/Balance';
import { FilterBalanceType } from '../../components/Balance/FilterType';
import { createFunctionalSetter } from '../storeCommons';

/**
 * @french
 * Interface des actions liées à la balance.
 */
export interface BalanceActions {
  setSelectedBalance: (balance: BalanceDto | null) => void;
  setSelectedBalances: (updater: BalanceRow[] | ((prev: BalanceRow[]) => BalanceRow[])) => void;
  setSelectedCompte: (compte: Compte | null) => void;
  setExportModalVisible: (visible: boolean) => void;
  setIsReaffectationModalVisible: (visible: boolean) => void;
  setModalTransferVisible: (visible: boolean) => void;
  setFilterLettrageActivation: (activation: boolean) => void;
  setSavedFilters: (
    updater:
      | Map<FilterBalanceType, any>
      | ((prev: Map<FilterBalanceType, any>) => Map<FilterBalanceType, any>),
  ) => void;
  reset: () => void;
}

/**
 * @french
 * Slice Zustand pour les actions de la balance.
 */
export const createBalanceSlice: StateCreator<
  BalanceState & BalanceActions,
  [],
  [],
  BalanceActions
> = (set, get) => ({
  setSelectedBalance: (balance) => set({ selectedBalance: balance }),
  setSelectedBalances: createFunctionalSetter(get, set, 'selectedBalances'),
  setSelectedCompte: (compte) => set({ selectedCompte: compte }),
  setExportModalVisible: (visible) => set({ exportModalVisible: visible }),
  setIsReaffectationModalVisible: (visible) => set({ isReaffectationModalVisible: visible }),
  setModalTransferVisible: (visible) => set({ modalTransferVisible: visible }),
  setFilterLettrageActivation: (activation) => set({ filterLettrageActivation: activation }),
  setSavedFilters: createFunctionalSetter(get, set, 'savedFilters'),
  reset: () => set(balanceInitialState),
});
